/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_TitleInputs */

const en_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently asked questions`)
};

const de_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haeufig gestellte Fragen`)
};

const fr_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const es_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const it_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const nl_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const pl_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const fi_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const da_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const sv_pricing_faq_title = /** @type {(inputs: Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

/**
* | output |
* | --- |
* | "Frequently asked questions" |
*
* @param {Pricing_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_title = /** @type {((inputs?: Pricing_Faq_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_title(inputs)
	if (locale === "fr") return fr_pricing_faq_title(inputs)
	if (locale === "es") return es_pricing_faq_title(inputs)
	if (locale === "it") return it_pricing_faq_title(inputs)
	if (locale === "nl") return nl_pricing_faq_title(inputs)
	if (locale === "pl") return pl_pricing_faq_title(inputs)
	if (locale === "fi") return fi_pricing_faq_title(inputs)
	if (locale === "da") return da_pricing_faq_title(inputs)
	if (locale === "sv") return sv_pricing_faq_title(inputs)
	return en_pricing_faq_title(inputs)
});